import { IpAddressWhitelists } from '@/features/ip_address_whitelists';
import { ToastProvider, useToast } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';

export type Props = {
  officeId: string;
};

const IpAddressWhitelistsPage: FC<Props> = ({ officeId }) => {
  const [toastApi, toastContextHolder] = useToast();

  return (
    <ToastProvider value={toastApi} contextHolder={toastContextHolder}>
      <IpAddressWhitelists officeId={officeId} />
    </ToastProvider>
  );
};

export default IpAddressWhitelistsPage;
